"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPluginStack = exports.createPluginStackWithAdapters = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _draftExtend = require("draft-extend");

var baseAccumulator = {
  __isAccumulator: true
};

var createPluginStackWithAdapters = function createPluginStackWithAdapters() {
  for (var _len = arguments.length, adapters = new Array(_len), _key = 0; _key < _len; _key++) {
    adapters[_key] = arguments[_key];
  }

  return function () {
    var allSets = [];
    var currentSet = [];

    for (var _len2 = arguments.length, plugins = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      plugins[_key2] = arguments[_key2];
    }

    plugins.forEach(function (plugin) {
      var accumulatorResult = plugin(baseAccumulator);
      var canBeCombined = accumulatorResult !== baseAccumulator;

      if (canBeCombined) {
        if (Array.isArray(accumulatorResult)) {
          if (currentSet.length > 0) {
            allSets = [].concat((0, _toConsumableArray2.default)(allSets), [currentSet]);
            currentSet = [];
          }

          allSets = [].concat((0, _toConsumableArray2.default)(allSets), (0, _toConsumableArray2.default)(accumulatorResult.map(function (stack) {
            return [stack];
          })));
          return;
        }

        currentSet = [].concat((0, _toConsumableArray2.default)(currentSet), [plugin]);
        return;
      }

      if (currentSet.length > 0) {
        allSets = [].concat((0, _toConsumableArray2.default)(allSets), [currentSet]);
        currentSet = [];
      }

      allSets = [].concat((0, _toConsumableArray2.default)(allSets), [[plugin]]);
    });

    if (currentSet.length > 0) {
      allSets = [].concat((0, _toConsumableArray2.default)(allSets), [currentSet]);
    }

    var combinedPluginStacks = allSets.map(function (pluginSet) {
      var reversedPluginSet = (0, _toConsumableArray2.default)(pluginSet).reverse();

      var pluginProps = _draftExtend.compose.apply(void 0, (0, _toConsumableArray2.default)(reversedPluginSet))(baseAccumulator);

      if (pluginProps === baseAccumulator) {
        if (pluginSet.length === 1) {
          return pluginSet[0];
        }

        return _draftExtend.compose.apply(void 0, (0, _toConsumableArray2.default)(pluginSet));
      }

      var numCombinedPlugins = pluginSet.length;

      if (numCombinedPlugins === 1 && !pluginProps.__pluginStack) {
        return pluginSet[0];
      }

      var displayName = pluginProps.__pluginStack || numCombinedPlugins + "(PluginStack)";
      return function (EditorComponent) {
        if (EditorComponent && EditorComponent.__isAccumulator) {
          return pluginProps;
        }

        if (EditorComponent.prototype && EditorComponent.prototype.isReactComponent) {
          return (0, _draftExtend.createPlugin)(Object.assign({}, pluginProps, {
            displayName: displayName
          }))(EditorComponent);
        }

        return _draftExtend.compose.apply(void 0, (0, _toConsumableArray2.default)(pluginSet))(EditorComponent);
      };
    });
    return function (arg) {
      if (arg && arg.__isAccumulator) {
        return combinedPluginStacks;
      }

      return _draftExtend.compose.apply(void 0, adapters).apply(void 0, (0, _toConsumableArray2.default)(combinedPluginStacks))(arg);
    };
  };
};

exports.createPluginStackWithAdapters = createPluginStackWithAdapters;
var createPluginStack = createPluginStackWithAdapters(_draftExtend.compose);
exports.createPluginStack = createPluginStack;